var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('i',{class:['fa', `fa-${_vm.name}`],attrs:{"aria-hidden":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }